<template>
  <div class="mod_privilege_slide">
    <Privilege :title="'VIP特权'"/>
  </div>

</template>

<script>
import Privilege from '@tencent/vft-component/VIP/Privilege'

export default {
  data () {
    return {

    }
  },
  components: {
    Privilege
  }
}
</script>

<style>
.mod_privilege_slide .left_show{display: none;}
.mod_privilege_slide .item {width: auto}
.mod_privilege_slide .mod_privilege .list{height: 166px}
.mod_privilege_slide .mod_privilege .list .item .top{border: none}
.mod_privilege_slide .mod_privilege .list .item .bottom{border: none}
.mod_privilege_slide .item:before,.mod_privilege_slide .item:after{background-image: none !important}

.page_skin_01 .mod_privilege .wrap_title{color: #fff}
.page_skin_01 .mod_privilege_slide .item .name{color: #808080}
.page_skin_01 .mod_privilege_slide .mod_privilege .list .item .top,.page_skin_01 .mod_privilege_slide .mod_privilege .list .item .bottom{border-right: 1px solid #1b1c1d  !important;border-bottom: 1px solid #1b1c1d !important}
.page_skin_02 .mod_privilege .wrap_title{color: #474541}
.page_skin_02 .mod_privilege_slide .item .name{color: #474541}
.page_skin_02 .mod_privilege_slide .mod_privilege .list .item .top,.page_skin_02 .mod_privilege_slide .mod_privilege .list .item .bottom{border-right: 1px solid #ede0d1 !important;border-bottom: 1px solid #ede0d1 !important}
.page_skin_03 .mod_privilege .wrap_title{color: #474541}
.page_skin_03 .mod_privilege_slide .item .name{color: #474541}
.page_skin_03 .mod_privilege_slide .mod_privilege .list .item .top,.page_skin_03 .mod_privilege_slide .mod_privilege .list .item .bottom{border-right: 1px solid #c4bdb0 !important;border-bottom: 1px solid #c4bdb0 !important}
.page_skin_04 .mod_privilege .wrap_title{color: #ac6b2b}
.page_skin_04 .mod_privilege_slide .item .name{color: #474541}
.page_skin_04 .mod_privilege_slide .mod_privilege .list .item .top,.page_skin_04 .mod_privilege_slide .mod_privilege .list .item .bottom{border-right: 1px solid #c29768 !important;border-bottom: 1px solid #c29768 !important}
.page_skin_05 .mod_privilege .wrap_title{color: #bf954b}
.page_skin_05 .mod_privilege_slide .item .name{color: #979797}
.page_skin_05 .mod_privilege_slide .mod_privilege .list .item .top,.page_skin_05 .mod_privilege_slide .mod_privilege .list .item .bottom{border-right: 1px solid #2c2621 !important;border-bottom: 1px solid #2c2621 !important}
</style>
